// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Sd from "common/src/tft-static/Sd.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Jotai from "jotai";
import * as React from "react";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as CdnAtom from "common/src/atoms/CdnAtom.bs.js";
import * as TbAtoms from "./TbAtoms.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as TraitImage from "common/src/tft-static/TraitImage.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as TraitTooltip from "common/src/tft-static/TraitTooltip.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";

function TbTraitsList(Props) {
  var setHighlightTrait = Props.setHighlightTrait;
  var units = Props.units;
  var traitCounts = Props.traitCounts;
  var onFilterTrait = Props.onFilterTrait;
  var chosenTrait = Props.chosenTrait;
  var exaltedUnits = Props.exaltedUnits;
  var basePath = CdnAtom.usePath(undefined);
  var set = TftSet.use(undefined);
  var match = Jotai.useAtom(TbAtoms.disableTooltips);
  var disableTooltips = match[0];
  var t = Translation.useT(/* Common */0);
  Jotai.useAtom(TbAtoms.compactMode);
  var traitsT = Translation.useT(/* Traits */2);
  var boardCount = Belt_Array.reduce(units, 0, (function (acc, param) {
          var traits = Sd.getUnitTraits(param[0], set);
          return acc + (
                  traits.includes("Set7_Dragon") ? 2 : 1
                ) | 0;
        }));
  var boardCost = Belt_Array.reduce(units, 0, (function (acc, param) {
          var sl = param[1];
          var uid = param[0];
          var cost = Sd.unitTier(uid);
          var traits = Sd.getUnitTraits(uid, set);
          var starMult = sl !== 3 ? (
              sl !== 4 ? 3 : 27
            ) : 9;
          return acc + Math.imul(Math.imul(cost, starMult), traits.includes("Set7_Dragon") ? 2 : 1) | 0;
        }));
  var activeUnits = Belt_Array.map(units, (function (prim) {
          return prim[0];
        }));
  return React.createElement(ContentSection.make, {
              className: "min-w-[200px] flex-1 overflow-hidden",
              children: null,
              noPadding: true
            }, React.createElement("div", {
                  className: "y-scroll ss-no-overflow pb-2 p-4 h-[calc(100%-40px)]"
                }, traitCounts.length === 0 ? React.createElement("div", {
                        className: "text-xl font-medium pb-4 text-white2"
                      }, t("Traits")) : null, Belt_Array.map(Belt_SortArray.stableSortBy(Belt_Array.map(traitCounts, (function (param) {
                                var count = param[1];
                                var tid = param[0];
                                var rank = Sd.traitRank(tid, count, set);
                                return [
                                        tid,
                                        count,
                                        rank
                                      ];
                              })), (function (param, param$1) {
                            var r2 = param$1[2];
                            var c = Caml.caml_int_compare(param[1], param$1[1]);
                            var cmp = c !== 0 ? -c | 0 : Caml.caml_string_compare(traitsT(param[0]), traitsT(param$1[0]));
                            if (param[2] !== 0) {
                              if (r2 !== 0) {
                                return cmp;
                              } else {
                                return -1;
                              }
                            } else if (r2 !== 0) {
                              return 1;
                            } else {
                              return cmp;
                            }
                          })), (function (param) {
                        var rank = param[2];
                        var traitId = param[0];
                        var minUnits = Sd.traitRankUnitCount(traitId, rank > 1 ? rank : 1, set);
                        var tmp = {
                          disabled: disableTooltips,
                          onOpen: (function (param) {
                              return Curry._1(setHighlightTrait, (function (param) {
                                            return traitId;
                                          }));
                            }),
                          onClose: (function (param) {
                              return Curry._1(setHighlightTrait, (function (param) {
                                            
                                          }));
                            }),
                          trait: traitId,
                          rank: rank,
                          activeUnits: activeUnits,
                          children: React.createElement("div", {
                                className: "flex items-center pb-2 cursor-pointer",
                                onClick: (function (param) {
                                    return Curry._1(onFilterTrait, traitId);
                                  })
                              }, React.createElement(TraitImage.make, {
                                    traitId: traitId,
                                    rank: rank,
                                    size: 28,
                                    chosen: Caml_obj.caml_equal(chosenTrait, traitId)
                                  }), React.createElement("div", {
                                    className: "pl-2 text-sm"
                                  }, String(param[1]) + "/" + String(minUnits) + " " + traitsT(traitId))),
                          key: traitId
                        };
                        var tmp$1 = exaltedUnits !== undefined && traitId === "TFT11_Exalted" ? exaltedUnits : undefined;
                        if (tmp$1 !== undefined) {
                          tmp.traitUnits = Caml_option.valFromOption(tmp$1);
                        }
                        return React.createElement(TraitTooltip.make, tmp);
                      }))), React.createElement(Tooltip.make, {
                  title: String(boardCount) + " board slots. " + String(boardCost) + " gold total board value.",
                  children: React.createElement("div", {
                        className: "flex justify-center items-center px-4 py-3 font-montserrat font-semibold elevation-2"
                      }, React.createElement("img", {
                            className: "mt-[-2px]",
                            height: "18",
                            src: basePath + "/general/tmp_board_count.png?width=18",
                            width: "18"
                          }), React.createElement("div", {
                            className: "pl-1 pr-3"
                          }, String(boardCount)), React.createElement("img", {
                            height: "16",
                            src: basePath + "/general/gold.png?width=16",
                            width: "16"
                          }), React.createElement("div", {
                            className: "pl-1"
                          }, String(boardCost)))
                }));
}

var make = TbTraitsList;

export {
  make ,
  
}
/* Sd Not a pure module */
